import {Component} from '@angular/core';
import {NgIf} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {Router, RouterLink} from '@angular/router';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatSnackBar} from "@angular/material/snack-bar";
import {CustomizerSettingsService} from '../../helpers/customizer-settings.service';
import { LocalStorageService } from '../../helpers/localStorage.service';
import { AuthService } from '../../apis/services/auth.service';

@Component({
    selector: 'sign-in',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule, NgIf],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss'
})
export class SignInComponent {

    // Remember Me toggle
    rememberMe = false;

    // Password Hide
    hide = true;

    // Form
    authForm: FormGroup;

    constructor(
        private _snackBar: MatSnackBar,
        private fb: FormBuilder,
        private router: Router,
        private localStorageService: LocalStorageService,
        private authService: AuthService,
        public themeService: CustomizerSettingsService
    ) {
        this.authForm = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]],
        });
        this.rememberMe = this.localStorageService.getItem('rememberMe') ?? false
    }

    onSubmit() {
        if (this.authForm.valid) {
            this.authService.login(this.authForm.get("username")?.value, this.authForm.get("password")?.value)
                .subscribe({
                    next: (res) => {
                        if ( res.jwtToken  && res.jwtToken?.length > 0) {
                            this.localStorageService.setItem('username', this.authForm.get("username")?.value);
                            this.router.navigateByUrl('/');
                        } else {
                            this._snackBar.open('Errore', 'Login non valido 1', {duration: 2500});
                        }
                    },
                    error: (error) => {
                        this._snackBar.open('Errore', 'Login non valido 2', {duration: 2500});
                        console.log(error);
                    }
                });
        } else {
            console.log('Form is invalid. Please check the fields.');
        }
    }

    // Card Border
    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    toggleRememberMe(state: boolean){
        this.rememberMe = state;
        this.localStorageService.setItem('rememberMe', state);
    }

}
